export const environmentTypes = Object.freeze({
    DEFAULT: 'default',
    ACCOUNTZONTRACK: 'accountzontrack',
    SREC: 'srec',
    MUTHAYAMMAL: 'muthayammal',
    TAGOREIET: 'tagoreiet',
    YI: 'yi'
});

export const environmentName = environmentTypes.DEFAULT;

export const ROLE = {
    ADMIN: 3,
    ASSESSOR: 4,
    ASSESSE: 5,
    ACADEMICCOUNCIL: 6
};

export const APP_LOGO_PATH = `${process.env.PUBLIC_URL}/static/images/quantsynx_logo.png`;